import {
  pageClick,
  wasItHelpfulView,
} from '@wix/bi-logger-customer-care-data/v2';
import { useRouter } from 'next/router';
import {
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react';

import { BI } from '../../../constants';
import { Context } from '../../../context';
import { useBI } from '../../../hooks/useBI';
import { useOnVisible } from '../../../hooks/useOnVisible';
import useWrongArticleVersion from '../../../hooks/useWrongArticleVersion';
import { mapPageTypeToSourceName } from '../../../utils/bi';

export const useWrongArticleBI = (articleId: string) => {
  const wrapperRef = useRef<HTMLDivElement>(null);
  const isVisible = useOnVisible(wrapperRef);
  const [isEventSent, setIsEventSent] = useState(false);
  const { sendBIEvent } = useBI();
  const { locale } = useRouter();
  const { pageType } = useContext(Context);
  const version = useWrongArticleVersion();

  const itemName = useMemo(() => {
    switch (version) {
      case 'versionA':
        return 'wrong article button 1';
      case 'versionB':
        return 'wrong article button 2';
      case 'versionC':
        return 'wrong article button 3';
      default:
        return '';
    }
  }, [version]);

  useEffect(() => {
    if (isVisible && !isEventSent && version) {
      sendBIEvent(
        wasItHelpfulView({
          source_name: mapPageTypeToSourceName(pageType),
          kb_lang: locale,
          item_id: articleId,
          item_name: itemName,
        }),
      ).catch(() => 0);
      setIsEventSent(true);
    }
  }, [
    isVisible,
    isEventSent,
    version,
    articleId,
    pageType,
    locale,
    sendBIEvent,
    itemName,
  ]);

  // Reset event sent flag when article changes
  useEffect(() => {
    setIsEventSent(false);
  }, [articleId]);

  // Handle button click event
  const onButtonClick = useCallback(
    async (clickedText: string) => {
      await sendBIEvent(
        pageClick({
          source_name: mapPageTypeToSourceName(pageType),
          kb_lang: locale,
          item_id: articleId,
          clicked_item_type: BI.CLICKED_ITEM_TYPES.WRONG_ARTICLE_BUTTON,
          clicked_text: clickedText,
          is_page_content_click: false,
        }),
      );
    },
    [sendBIEvent, pageType, locale, articleId],
  );

  return { wrapperRef, onButtonClick };
};
